import JSEncrypt from 'jsencrypt';
import crypto from 'crypto';

// 公钥加密
export function encryptRSA(text, key) {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(key);
    const encrypted = encrypt.encrypt(text);
    return encrypted;
}

// 私钥解密
export function decryptRSA(text, key) {
    const decrypt = new JSEncrypt();
    decrypt.setPrivateKey(key);
    const decrypted  = decrypt.decrypt(text);
    return decrypted;
}

export function signFn(text, key) {
    const sign = crypto.createSign('RSA-SHA1');
    sign.update(text);
    sign.end();
    return sign.sign(key).toString('base64');
}

export function verifyFn(text, sign, publicKey) {
    const verify = crypto.createVerify('RSA-SHA1');
    verify.update(text);
    verify.end();
    return verify.verify(publicKey, Buffer.from(sign, 'base64'));
}